import { render, staticRenderFns } from "./WinnerList.vue?vue&type=template&id=01e8988e&scoped=true&"
import script from "./WinnerList.vue?vue&type=script&lang=js&"
export * from "./WinnerList.vue?vue&type=script&lang=js&"
import style0 from "./WinnerList.vue?vue&type=style&index=0&id=01e8988e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e8988e",
  null
  
)

export default component.exports